/**
 * ハンバーガーメニューの「利用規約 / プライバシーポリシー / マニュアル」で
 * 表示する文面の型定義と束ね役。
 *
 * 文面本体は文書ごとに `infoDocs/` 配下のファイルに分割している（1ファイルの
 * 肥大化を避けるため）。表示側（InfoModal）は構造化データを描画するだけなので、
 * 各文書を更新する場合は対応するファイルを編集する。
 *
 * 注意: 利用規約・プライバシーポリシーには運営者固有の記載（運営者名・連絡先）
 * のプレースホルダ【】が残っている。公開前に実際の値へ置き換えること。
 */

import { TERMS_DOC } from './infoDocs/terms';
import { PRIVACY_DOC } from './infoDocs/privacy';
import { MANUAL_DOC } from './infoDocs/manual';

/** メニューから開ける情報ドキュメントの種別。 */
export type InfoKey = 'terms' | 'privacy' | 'manual';

/** ドキュメント内の1セクション（見出し + 段落の配列）。 */
export interface InfoSection {
  /** セクション見出し（省略時は段落のみ描画）。 */
  readonly heading?: string;
  /** 段落テキストの配列。各要素が1つの段落として描画される。 */
  readonly body: readonly string[];
}

/** 1つの情報ドキュメント。 */
export interface InfoDoc {
  /** モーダルのタイトル。 */
  readonly title: string;
  /** 本文セクション。 */
  readonly sections: readonly InfoSection[];
}

export const INFO_DOCS: Record<InfoKey, InfoDoc> = {
  terms: TERMS_DOC,
  privacy: PRIVACY_DOC,
  manual: MANUAL_DOC,
};
